import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { featureGroups } from "@/data/siteContent";
import { Reveal } from "@/components/Reveal";
import { motion } from "framer-motion";
import { FEATURES } from "@/constants/testIds";

export const Features = () => {
  return (
    <section id="funzionalita" data-testid={FEATURES.section} className="py-16 sm:py-24">
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <p className="text-sm font-semibold text-accent uppercase tracking-wider">Funzionalità</p>
          <h2 className="mt-2 text-3xl sm:text-4xl font-semibold tracking-tight">Tutto per proteggere la tua famiglia</h2>
          <p className="mt-4 text-muted-foreground text-base leading-relaxed">
            Una suite completa per il controllo parentale, organizzata per categoria. Ogni strumento è pensato per un uso
            trasparente e conforme alla legge, con il consenso di chi utilizza il dispositivo.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-10">
          <Tabs defaultValue={featureGroups[0].id} data-testid={FEATURES.tabs} className="w-full">
            <TabsList className="flex flex-wrap h-auto gap-1 bg-secondary/70 p-1.5 rounded-xl">
              {featureGroups.map((g) => (
                <TabsTrigger key={g.id} value={g.id} className="rounded-lg px-4 py-2 text-sm data-[state=active]:glow">
                  {g.label}
                </TabsTrigger>
              ))}
            </TabsList>

            {featureGroups.map((g) => (
              <TabsContent key={g.id} value={g.id} className="mt-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                  {g.items.map((item, i) => (
                    <motion.div
                      key={item.title}
                      initial={{ opacity: 0, y: 18 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.4, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
                    >
                      <Card className="h-full p-6 rounded-2xl border-border card-lift glow-hover bg-card">
                        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-accent glow">
                          <item.icon className="h-5 w-5" strokeWidth={1.75} />
                        </span>
                        <h3 className="mt-4 text-lg font-semibold">{item.title}</h3>
                        <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{item.desc}</p>
                      </Card>
                    </motion.div>
                  ))}
                </div>
              </TabsContent>
            ))}
          </Tabs>
        </Reveal>
      </div>
    </section>
  );
};
